// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStateInfoDto
 */
export interface IStateInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IStateInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IStateInfoDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IStateInfoDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IStateInfoDto interface.
 */
export function instanceOfIStateInfoDto(value: object): value is IStateInfoDto {
    return true;
}

export function IStateInfoDtoFromJSON(json: any): IStateInfoDto {
    return IStateInfoDtoFromJSONTyped(json, false);
}

export function IStateInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStateInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IStateInfoDtoToJSON(json: any): IStateInfoDto {
    return IStateInfoDtoToJSONTyped(json, false);
}

export function IStateInfoDtoToJSONTyped(value?: IStateInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

